import {Checkbox} from '../Checkbox';
import {Typography} from '../Typography';

import type {ReactNode, FC} from 'react';

export interface CheckboxFilterOption {
  value: string;
  label: ReactNode;
}

export interface ListFilterCheckboxSectionProps {
  title: string;
  options: ReadonlyArray<CheckboxFilterOption>;
  selected: string[];
  onChange: (selected: string[]) => void;
}

export const ListFilterCheckboxSection: FC<ListFilterCheckboxSectionProps> = ({
  title,
  options,
  selected,
  onChange
}) => {
  const toggle = (value: string) => {
    const next = selected.includes(value)
      ? selected.filter(s => s !== value)
      : [...selected, value];
    onChange(next);
  };

  return (
    <div data-slot="list-filter-checkbox-section">
      <div className="px-3 pb-1 pt-2">
        <Typography size="xs" weight="semibold" color="tertiary">
          {title}
        </Typography>
      </div>
      {options.map(opt => (
        <label
          key={opt.value}
          className="flex w-full cursor-pointer items-center gap-2 rounded-sm px-2 py-1.5 text-sm text-fg hover:bg-background-surface_hover"
        >
          <Checkbox
            checked={selected.includes(opt.value)}
            onCheckedChange={() => toggle(opt.value)}
          />
          <span className="min-w-0 flex-1 text-start">{opt.label}</span>
        </label>
      ))}
    </div>
  );
};
